<template>
  <form-container :title="stageTitle">
    <p class="lead">If you would like to read our guide to making a gadget claim <router-link to="/claimsguide">click here</router-link>.</p>
    <p class="lead">If you have a saved claim form that you wish to resume, <router-link to="/makeaclaim/resume">click here</router-link>.</p>
    <div class="form-group">
      <label for="policy number">Policy number</label>
      <input type="text" 
            id="policyNumber" 
            fieldlabel="Policy number"
            v-model="number"
            v-taurus-validator="'required'"
            class="form-control form-control-lg">
      <div class="" name="policyNumber" invalidfeedback="Please enter a valid policy number"></div>
    </div>
    
    <div class="form-group">
      <label for="policyholders date of birth">Policyholder's date of birth</label>
      <input type="text" 
            id="policyDOB"                  
            fieldlabel="Policyholder's date of birth" 
            placeholder="DD/MM/YYYY" 
            v-model="dob" 
            v-taurus-validator="'required|date_format:DD/MM/YYYY'" 
            class="form-control form-control-lg">
      <div class="" name="policyDOB" invalidfeedback="Please enter the policyholder's date of birth in the following format DD/MM/YYYY"></div>
    </div>

    <label for="policy holder's postcode">Policyholder's postcode</label>
    <input type="text" 
          id="policyPostcode" 
          ref="policyPostcode" 
          fieldlabel="Policyholder's postcode" 
          placeholder="" 
          v-model="postcode" 
          v-taurus-validator="'required'" 
          class="form-control form-control-lg">
    <div class="" name="policyPostcode" invalidfeedback="Please enter policyholder's postcode"></div>
    
    <label for="incidentDate">Date of the incident</label>
    <datepicker fieldlabel="Incident date"
                id="incidentDate"                     
                :format="customDateFormatter" 
                v-model="dateOfIncident" 
                :disabled-dates="disabledDatesInFuture()" 
                v-taurus-validator="'required'"/>
    <div name="incidentDate" invalidfeedback="Please enter the date of the incident in the following format DD/MM/YYYY"></div>
    
    <transition name="fade">
      <form-alert :show="apiMsg.type != 0 && nextAttempted" :flavour="2" :resellerId="77">
        {{apiMsg.text}}
      </form-alert>
        <!-- <div
            v-if="apiMsg.type != 0 && nextAttempted"
            class="text-danger mt-5 mb-5">
            <i class="fas fa-exclamation-triangle mr-2"></i><strong>{{apiMsg.text}}</strong>
        </div> -->
    </transition>
    <form-button-bar
        :back_button_show='false'
        :next_button_enable='true'
        :next_button_show='true'
        :next_button_icon_enable='true'
        :next_button_action='handleNextClick' />


    <loading :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"></loading>

    <b-modal title="Policy Warning" ref="redirection-modal" header-text-variant="danger" ok-only ok-title="Proceed" @ok="redirect()">
      <p>Your policy cannot be processed in this portal. Please <a :href="redirectUrl">go to the correct portal</a> to access your policy.</p>
    </b-modal>
  </form-container>
</template>

<script>

import standaloneClaimForm from '../../mixins/tigaClaimForm'
import FormContainer from '@/components/FormContainer.vue'
import FormAlert from '@/components/FormAlert.vue'
import FormButtonBar from '@/components/standaloneForm/FormButtonBar.vue'

import loading from 'vue-loading-overlay'

import datepicker from '@/components/taurus-datepicker/components/Datepicker.vue'
import moment from 'moment'

let isDate = (value) => {
  
  var s = value.split("/");
  if (s[0] < 1 || s[0] > 31) {
    return false
  }

  if (s[1] < 1 || s[1] > 12)
  {
    return false
  }

  var d = new Date(s[2], s[1], s[0]);

  //var d = Date.parse(value)
  return new Date(d) instanceof Date && !isNaN(d)
}

export default {
  name: 'policyLookup',
  components: {
    loading,
    FormContainer,
    FormButtonBar,
    datepicker,
    FormAlert
  },
  data () {
    return {
      number: '',
      dob: '',
      postcode: '',
      testValid: 'required',
      nextAttempted: false,
      redirectUrl: ''
    }
  },
  mixins: [
    standaloneClaimForm
  ],
  beforeCreate() {
    this.$thisIsAForm = true
  },
  mounted () {
    this.reset()
  },
  computed: {
    dateOfIncident: {
      get () {
        return this.$store.state.claimform.claimForm.data.incident.dateOfIncident
      },
      set (value) {
        this.$store.commit('claimform/setIncidentDate', { dateOfIncident: value })
      }
    },
    stageTitle() {
      return this.$textManager.getText("title", this.$route.name)
    }
  },
  methods: {
    handleNextClick () {
      this.nextAttempted = true
      if (this.checkForm()) {
        this.lookupPolicy(this.number, this.dob, this.postcode, { path: '2' })
      }      
    },
    customDateFormatter (date) {
      return moment(date).format('DD/MM/YYYY')
    },
    disabledDatesInFuture () {
      return {
        from: new Date()
      }
    },
    policyRedirect() {
      this.$refs['redirection-modal'].show()         
    },
    redirect() {
      window.location.href = this.redirectUrl
    }
  }
}
</script>


